import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 445px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
`;

export const InformationWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;
